export default "__VITE_ASSET__CrtZWd00__"